import {
    CogIcon,
    HeroVideoCameraIconSolid,
    HeroXMarkIcon,
} from '../Icon'
import {
    Dropdown,
    DropdownButtonNew as DropdownButton,
    DropdownContent,
} from '../Dropdown'
import {
    SidebarChannel,
    SidebarChannelViewProps,
    SidebarChannelsViewProps,
} from './types'
import {
    styledButton,
    styledContent,
    styledGroup,
    styledList,
    styledName,
    styledStatus,
} from 'components/Sidebar/styles'
import Button from '../Button'
import {Icon} from '../Icon/types'
import LeaveChannelPromiseModal from 'components/Modal/LeaveChannelPromiseModal'
import LetterAvatar from '../Avatar/LetterAvatar'
import React from 'react'
import permissionGuard from 'components/Navigation/helpers/PermissionGuard'
import {styled} from 'stitches/config'
import {styledItem} from 'components/Dropdown/styles'
import {useChannelDetails} from '../../hooks/ninchat'
import {usePromiseModal} from '../Modal/PromiseModal/hooks/usePromiseModal'
import {useTranslation} from 'react-i18next'

const StyledGroup = styled('ul', styledGroup)
const StyledList = styled('li', styledList)
const StyledContent = styled('div', styledContent)
const StyledButton = styled('button', styledButton)
const StyledName = styled('div', styledName)
const StyledStatus = styled('div', styledStatus)

const StyledItem = styled('div', styledItem)

const SidebarChannelView = ({
    channel_id,
    loadChannel,
    loadChannelSettings,
}: SidebarChannelViewProps): React.ReactElement => {
    const {t} = useTranslation()
    const channelDetails = useChannelDetails({channelId: channel_id})
    const openLeaveChannelModal = usePromiseModal(LeaveChannelPromiseModal, {instanceId: 'leaveChannel'})

    const hasChannelPermission = permissionGuard.hasManageRealmChannelPermissions(channel_id)

    const leaveChannel = (): void => {
        openLeaveChannelModal({
            channelId: channel_id,
            channelName: channelDetails.name,
        }).then(
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            () => {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            () => {},
        )
    }

    return (
        <StyledList key={channel_id}>
            <StyledContent>
                <StyledButton
                    active={channelDetails.isSelected}
                    onClick={() => loadChannel(channel_id)}
                    type='button'
                >
                    <LetterAvatar
                        highlight={channelDetails.channelStatus === 'highlight'}
                        name={channelDetails.name}
                        size='small'
                        unread={channelDetails.channelStatus === 'unread'}
                    />
                    <StyledName status={channelDetails.channelStatus}>{channelDetails.name}</StyledName>
                    {!!channelDetails.isVideoChannel &&
                        <StyledStatus active={channelDetails.isVideoActive}><span title={t('Video meeting channel')}><HeroVideoCameraIconSolid size={14} /></span></StyledStatus>}
                </StyledButton>
                <Dropdown>
                    <DropdownButton caret={true} color='text' data-id='dropdown-caret' size='small' />
                    <DropdownContent direction='fixed-end'>
                        {!!hasChannelPermission &&
                            <StyledItem>
                                <Button
                                    color='text'
                                    iconLeft={CogIcon}
                                    onPress={(): void => { loadChannelSettings(channel_id) }}
                                    text={t('Channel settings')}
                                    type='button'
                                />
                            </StyledItem>}
                        <StyledItem>
                            <Button
                                color='text'
                                iconLeft={HeroXMarkIcon as unknown as Icon}
                                onPress={() => leaveChannel()}
                                text={t('Leave channel')}
                                type='button'
                            />
                        </StyledItem>
                    </DropdownContent>
                </Dropdown>
            </StyledContent>
        </StyledList>
    )
}


export const SidebarChannelsView = ({
    channels,
    loadChannel,
    loadChannelSettings,
}: SidebarChannelsViewProps): React.ReactElement => {
    const {t} = useTranslation()

    return (
        <>
            {channels?.length > 0 &&
            <StyledGroup aria-label={t('Channels')}>
                {channels.map(({channel_id}: SidebarChannel) => (
                    <SidebarChannelView
                        channel_id={channel_id}
                        key={channel_id}
                        loadChannel={loadChannel}
                        loadChannelSettings={loadChannelSettings}
                    />))}
            </StyledGroup>}
            {}
        </>
    )
}
